import React from "react";
import "./style.css";
import coachesImage1 from "../../../Assets/Images/Coaches/Logan.png";
import coachesImage2 from "../../../Assets/Images/Coaches/Nick-Vollaro.png";
import coachesImage3 from "../../../Assets/Images/Coaches/Logan1.png";
import coachesImage4 from "../../../Assets/Images/Coaches/Nina1.png";
import coachesImage5 from "../../../Assets/Images/Coaches/Rob-Stein-3.png";
import coachesImage6 from "../../../Assets/Images/Coaches/Nina.png";
import coachesImage7 from "../../../Assets/Images/Coaches/Vin-DaCunto.png";
import coachesImage8 from "../../../Assets/Images/Coaches/Rob-Stein-4.png";
const ImageGrid = () => {
  // Sample dynamic data
  const data = [
    { id: 1, title: "Eric Wiese", image: coachesImage3 },
    { id: 2, title: "Logan Dally", image: coachesImage1 },
    { id: 3, title: "Nina Romano", image: coachesImage6 },
    { id: 4, title: "Vincent D'Acunto", image: coachesImage7 },

    { id: 5, title: "Nick Vollaro", image: coachesImage2 },
    { id: 6, title: "Gianna Burnett", image: coachesImage4},
    { id: 7, title: "Rob Stein", image: coachesImage8 },

    { id: 8, title: "Nico Rivera", image: coachesImage5 }
  ];

  return (
    <div className="grid-container">
      {data.map((item) => (
        <div className="grid-item" key={item.id}>
          <img src={item.image} alt={item.title} />
          <div className="title">{item.title}</div>
        </div>
      ))}
    </div>
  );
};

export default ImageGrid;
